import requirementApi from '@/fetch/bussiness/collectionTask';
import { HttpStatusCode } from '@/fetch/core/constant';
import { Button, message, Modal, Select } from 'antd';
import React, { useState } from 'react';

const AddTagModal: React.FC<{
  open?: boolean;
  onClose: () => void;
  tagOptionList: Array<{ value: string | number; label: string }>;
  onConfirm: (tagData: { tagId: number; tagName: string }) => void;
  onRefreshTagList?: () => Promise<void>; // 新增：刷新标签列表的回调
}> = (props) => {
  const [selectedValue, setSelectedValue] = useState<number | undefined>(
    undefined
  );
  const [searchValue, setSearchValue] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const handleSelectChange = (value: number) => {
    setSelectedValue(value);
  };

  const handleSearch = (value: string) => {
    if (value?.length > 30) {
      return;
    }
    setSearchValue(value?.trim());
  };

  // 高亮匹配文本的函数
  const highlightText = (text: string, searchText: string) => {
    if (!searchText) return text;

    const regex = new RegExp(`(${searchText})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="search-highlight">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const handleClose = () => {
    setSelectedValue(undefined);
    setSearchValue('');
    setDropdownOpen(false);
    props.onClose();
  };

  const handleSave = () => {
    if (typeof selectedValue === 'number') {
      const selectedOption = props.tagOptionList?.find(
        (option) => option.value === selectedValue
      );
      if (selectedOption) {
        props.onConfirm({
          tagId: selectedOption.value as number,
          tagName: selectedOption.label,
        });
        // 保存成功后清除状态
        setSelectedValue(undefined);
        setSearchValue('');
        setDropdownOpen(false);
      }
    }
  };
  return (
    <Modal
      title="添加标签"
      open={props.open}
      onCancel={handleClose}
      footer={null}
      width={600}
      className="edit-tag-modal"
      destroyOnHidden
    >
      <div className="modal-content">
        <div className="input-section inline-layout">
          <div className="input-label">搜索或新建标签</div>
          <Select
            value={selectedValue}
            onChange={handleSelectChange}
            onSearch={handleSearch}
            placeholder="请选择标签"
            className="tag-select"
            showSearch
            allowClear
            searchValue={searchValue}
            open={dropdownOpen}
            onDropdownVisibleChange={setDropdownOpen}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={props.tagOptionList}
            optionRender={(option) => (
              <div className="custom-option">
                <span className="option-text">
                  {highlightText(String(option.label || ''), searchValue)}
                </span>
              </div>
            )}
            dropdownRender={(menu) => (
              <div>
                {searchValue &&
                  !props.tagOptionList?.some((option) =>
                    option.label
                      .toLowerCase()
                      .includes(searchValue.toLowerCase())
                  ) && (
                    <div
                      className="create-new-option"
                      onClick={async () => {
                        setDropdownOpen(false);
                        try {
                          const res = await requirementApi.addTag(searchValue);
                          if (res?.code === HttpStatusCode.Success) {
                            const newTagId = res?.data?.tagId;
                            const newTagName = res?.data?.tagName;
                            // 先刷新标签列表数据
                            if (props.onRefreshTagList) {
                              await props.onRefreshTagList();
                            }

                            // 数据刷新完成后，设置新创建的标签为选中状态
                            const timer = setTimeout(() => {
                              clearTimeout(timer);
                              setSelectedValue(newTagId);
                            }, 100);
                            setSearchValue('');
                            message.success(`成功新建标签 "${searchValue}"`);
                          } else {
                            message.error('标签创建失败');
                          }
                        } catch (error) {}
                      }}
                    >
                      <i style={{ whiteSpace: 'nowrap' }}>点击新建「</i>
                      <span className="highlight">{searchValue}</span>
                      <i style={{ whiteSpace: 'nowrap' }}>」标签</i>
                    </div>
                  )}
                {menu}
              </div>
            )}
          />
        </div>

        <div className="modal-footer single-button">
          <Button
            type="primary"
            onClick={handleSave}
            disabled={!selectedValue}
            className="confirm-btn"
          >
            确定
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddTagModal;
